export function downloadCsv(name, cols, rows) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [cols.map((c) => esc(c[1])).join(","), ...rows.map((r) => cols.map((c) => esc(typeof c[0] === "function" ? c[0](r) : r[c[0]])).join(","))].join("\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  a.download = name;
  a.click();
}
